import { FontFamily } from "../../constants";

export const TypographyFontFamily = FontFamily;

export const MapTypographyFontFamilyToCN = {
  [TypographyFontFamily.bebas]: "bebas",
  [TypographyFontFamily.roboto]: "roboto",
};

export const TypographyColor = {
  inherit: "inherit",
  primary: "primary",
  primaryLight: "primary-light",
  gray: "gray",
  iconHover: "icon-hover",
  white: "white",
  formLabelColor: "form-label-color",
  textInactive: "text-inactive",
  textLink: "text-link",
  default: "default",
  iconDisabled: "icon-disabled",
  waterMark: "water-mark",
  searchSectionPrimary: "search-section-primary"
};
export const TypographyColorToCNMap = {
  [TypographyColor.inherit]: "inherit",
  [TypographyColor.primary]: "primary",
  [TypographyColor.primaryLight]: "primary-light",
  [TypographyColor.gray]: "gray",
  [TypographyColor.white]: "white",
  [TypographyColor.formLabelColor]: "form-label-color",
  [TypographyColor.textInactive]: "text-inactive",
  [TypographyColor.textLink]: "text-link",
  [TypographyColor.default]: "default",
  [TypographyColor.iconDisabled]: "icon-disabled",
  [TypographyColor.iconHover]: "icon-hover",
  [TypographyColor.waterMark]: "water-mark",
  [TypographyColor.searchSectionPrimary]: "search-section-primary",
};

export const TypographyAlign = {
  left: "left",
  center: "center",
  right: "right",
};

export const TypographyAlignToClassNameMap = {
  [TypographyAlign.left]: "l",
  [TypographyAlign.center]: "c",
  [TypographyAlign.right]: "r"
};


export const TypographyLetterSpacing = {
  big: "big",
  sm: "sm",
};

export const TypographyLetterSpacingToClassNameMap = {
  [TypographyLetterSpacing.big]: "ls-big",
  [TypographyLetterSpacing.sm]: "ls-sm"
};

export const TypographyVariant = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "subtitle1",
  body1: "body1",
  body2: "body2",
  body3: "body3",
  body4: "body4",
  body5: "body5",
};

export const TypographyVariantToTagMap = {
  [TypographyVariant.h1]: "h1",
  [TypographyVariant.h2]: "h2",
  [TypographyVariant.h3]: "h3",
  [TypographyVariant.h4]: "h4",
  [TypographyVariant.h5]: "h5",
  [TypographyVariant.h6]: "h6",
  [TypographyVariant.subtitle1]: "h3",
  [TypographyVariant.body1]: "p",
  [TypographyVariant.body2]: "p",
  [TypographyVariant.body3]: "p",
  [TypographyVariant.body4]: "span",
  [TypographyVariant.body5]: "span",
};
